import { Box, VStack } from '@enechain/ecloud-designsystem'

import type { IntradayOrderRow } from '~/hooks/bidding/useListBiddingIntradayOrders'
import { IntradayOrderTable } from '~/pages/IntradayBidding/components/IntradayOrderTable'

type Props = {
  rows: IntradayOrderRow[]
  isLoading: boolean
}

/**
 * 入札履歴 tab (read-only)。 JEPX へ出す前の札と入札中の札は呼び出し側で除く (AC-BIN-024)。
 */
export const BidHistoryTab = ({
  rows,
  isLoading,
}: Props): React.ReactElement => (
  <VStack align="stretch" gap={3}>
    {/* 縦は page スクロールに委譲、 横のみ table 側に委譲 (= spot.html と同方針)。 */}
    <Box overflowX="auto">
      <IntradayOrderTable isLoading={isLoading} rows={rows} />
    </Box>
  </VStack>
)
